import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'sortChartData',
})
export class SortChartDataPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    if (!Array.isArray(value)) {
      return [];
    }
    return _.orderBy(value, ['value'], ['desc']);
  }
}
